import React from 'react';
import { DISPOSITION_OPTIONS, STATUS_SHORT_LABEL, getStatusColor } from './constants';

// Top dashboard cards: total, per-status counts (clickable to filter), total
// reimbursed and the product cost of the reimbursed units. `stats` is computed
// once in the container from already-parsed data.
export default function CaseStatsBar({ stats, statusFilter, onToggleStatus }) {
    return (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-8 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow p-4 border-l-4 border-gray-500">
                <div className="text-2xl font-bold text-gray-900">{stats.total}</div>
                <div className="text-sm text-gray-600">Total Cases</div>
            </div>

            {DISPOSITION_OPTIONS.map((status) => {
                const colors = getStatusColor(status);
                const active = statusFilter === status;
                return (
                    <React.Fragment key={status}>
                        <button
                            type="button"
                            onClick={() => onToggleStatus(active ? 'all' : status)}
                            className={`text-left bg-white rounded-lg shadow p-4 border-l-4 cursor-pointer transition-all hover:shadow-md ${
                                active ? 'ring-2 ring-blue-500' : ''
                            }`}
                            style={{ borderLeftColor: colors.borderColor }}
                        >
                            <div className="flex items-center gap-2">
                                <div className={`w-2 h-2 rounded-full ${colors.dot}`} />
                                <div className="text-2xl font-bold text-gray-900">{stats[status] || 0}</div>
                            </div>
                            <div className="text-xs text-gray-600 truncate" title={status}>
                                {STATUS_SHORT_LABEL[status] || status}
                            </div>
                        </button>

                        {status === 'Resolved-Inventory or Refund Processed' && (
                            <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-lg shadow p-4 border-l-4 border-emerald-500">
                                <div className="flex items-center gap-1">
                                    <span className="text-lg text-emerald-600">$</span>
                                    <span className="text-2xl font-bold text-emerald-700">
                                        {stats.totalReimbursement.toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </span>
                                </div>
                                <div className="text-xs text-emerald-600 font-medium">Total Reimbursed</div>
                            </div>
                        )}

                        {status === 'Resolved-Inventory or Refund Processed' && (
                            <div
                                className="bg-gradient-to-br from-sky-50 to-blue-100 rounded-lg shadow p-4 border-l-4 border-blue-500"
                                title={
                                    stats.reimbursedCasesMissingCost
                                        ? `${stats.reimbursedCasesMissingCost} of ${stats.reimbursedCases} reimbursed cases have no price-list cost and are excluded`
                                        : `Price-list cost of the units on ${stats.reimbursedCases} reimbursed cases`
                                }
                            >
                                <div className="flex items-center gap-1">
                                    <span className="text-lg text-blue-600">$</span>
                                    <span className="text-2xl font-bold text-blue-700">
                                        {stats.reimbursedUnitCost.toLocaleString('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                    </span>
                                </div>
                                <div className="text-xs text-blue-600 font-medium">Reimbursed Unit Cost</div>
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
